import React from 'react';

import { Tooltip } from '@opendoor/bricks';

interface IProps {
  email: string;
  onNewUserSubmit: (email: string, password: string) => void;
  newUserSubtitle?: string;
  newUserTitle?: string;
}

interface IState {
  errorMsg: string;
  password?: string;
  ['password-confirm']?: string;
}

export default class NewUserForm extends React.Component<IProps, IState> {
  public static defaultProps: Partial<IProps> = {
    newUserSubtitle: 'Finish setting up your account to review your Opendoor contract.',
    newUserTitle: 'Ready to take a look at your contract?',
  };

  public state = { errorMsg: null, password: null };

  public render() {
    const { newUserSubtitle, newUserTitle } = this.props;
    const { errorMsg } = this.state;

    return (
      <form onSubmit={this.onSubmit}>
        <h1 className="new-account-header">{newUserTitle}</h1>
        <p className="new-account-subheader">{newUserSubtitle}</p>
        <div className="input-section">
          <div className="field-label">
            <b>Email address</b>
            <Tooltip>
              Your Opendoor account is connected to the email you use to request your offer. You can
              always update this after you create your account.
            </Tooltip>
          </div>
          <div className="field-text">
            <p>{this.props.email}</p>
          </div>
          <div className="field-label">
            <p>
              <b>Create a password</b>
              &nbsp; (5+ characters)
            </p>
          </div>
          {errorMsg && <p className="text-red">{errorMsg}</p>}
          <input
            className="input-field"
            type="password"
            placeholder="Password"
            name="password"
            onChange={this.handleChangePassword}
            required={true}
          />
          <input
            className="input-field"
            type="password"
            placeholder="Confirm password"
            name="password-confirm"
            onChange={this.handleChangePassword}
            required={true}
          />
          <button className="button primary submit-button">
            {/* TODO: loading spinner? disable button if request is in progress? (prevent double-submit) */}
            Create account
          </button>
        </div>
      </form>
    );
  }

  private handleChangePassword = e => {
    const fieldName = e.target.name;
    this.setState({ [fieldName]: e.target.value });
  };

  private onSubmit = e => {
    e.preventDefault();
    let errorMsg = null;

    if (this.state.password.length < 5) {
      errorMsg = 'Your password must be at least 5 characters long';
    } else if (this.state.password !== this.state['password-confirm']) {
      errorMsg = 'Passwords do not match.';
    } else {
      // No validation issues.
      this.props.onNewUserSubmit(this.props.email, this.state.password);
    }

    this.setState({ errorMsg });
  };
}
